<template>

    <div class="page_content module_course" aria-label="Course Dashboard Page Content" v-show="!showLastActivity">

        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

        <div class="row page_content_container" v-if="isCourseDetailLoaded">

            <channel></channel>

            <div class="col-11 dasboard-left-section dashboard_container">
                <b-col cols="12" class="course-description">
                <b-row class="dashboard-row">

                  <b-col cols="3" class="col-xl-3 col-lg-6 col-md-12 col-sm-12">

                      <div class="card ace_sec" aria-label="Action Section">

                          <div class="card-header">
                            <span class="icon float-left icon-directions_run text-center mr-2"></span>
                            <span class="label ace_sec_hd" role="heading" aria-level="1" aria-label="Current learning activity">Action</span>
                          </div>

                          <div class="card-body action-section">
                            <div v-if="isContinueLearningReady && !isOpenCourse">
                              <div v-if="continueLearningOptions.length !== 0" class="content">
                                <!--- Length === 1 -->
                                <!--- Title === COURSE_FINISHED -->
                                <div v-if="continueLearningOptions.length === 1 && continueLearningOptions[0].title === 'COURSE_FINISHED'">
                                  <div class="card-text ace_sec_txt">
                                    Congratulations! You have completed all competencies.
                                  </div>
                                </div>
                                <!--- Length === 1 -->
                                <div v-if="continueLearningOptions.length === 1 && continueLearningOptions[0].title !== 'COURSE_FINISHED'">
                                  <template v-if="!continueLearningOptions[0].startStatus">
                                    <div class="card-text" tabindex="0"><span class="first-row">You were working on <i :title="continueLearningOptions[0].title">{{continueLearningOptions[0].title}}</i></span> <span class="second-row">are you ready to continue?</span></div>
                                    <div class="row d-flex justify-content-center">
                                          <span class="float-left toc_row row_3 active_row"></span>
                                          <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, action: 'clickContinueLearning', showLastActivity: this.showLastActivity} }" class="more-link continue-learning float-left">Continue Learning</b-link>
                                    </div>
                                  </template>
                                  <template v-if="continueLearningOptions[0].startStatus">
                                    <div class="card-text ace_sec_txt">Welcome, are you ready to get started?</div>
                                    <div class="row d-flex justify-content-center" style="margin-top: 20px;">
                                        <span class="float-left toc_row row_3 active_row"></span>
                                        <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, action: 'clickStartLearning', showLastActivity: this.showLastActivity } }" class="more-link continue-learning float-left">Start Learning</b-link>
                                    </div>
                                  </template>
                                </div>
                                <!--- Length > 1 -->
                                <div v-if="continueLearningOptions.length > 1">
                                  <div class="card-text ace_sec_txt" v-if="continueLearningOptions[1].title !== 'COURSE_LAUNCH'"><span class="first-row">You completed <i :title="continueLearningOptions[1].title">{{continueLearningOptions[1].title}}</i> !</span> <span class="second-row">Are you ready to work on <i :title="continueLearningOptions[0].title">{{continueLearningOptions[0].title}}</i> ?</span></div>
                                  <div class="row d-flex justify-content-center">
                                        <span class="float-left toc_row row_3 active_row"></span>
                                        <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, action: 'clickContinueLearning', showLastActivity: this.showLastActivity } }" class="more-link continue-learning float-left">Continue Learning</b-link>
                                  </div>
                                </div>
                              </div>

                              <div v-else class="content">
                                  <div class="card-text ace_sec_txt">Welcome, are you ready to get started?</div>
                                  <div class="row d-flex justify-content-center" style="margin-top: 20px;">
                                      <span class="float-left toc_row row_3 active_row"></span>
                                      <b-link :to="{ name: 'courseLearn', params: { uuid: course.uuid } }" class="more-link continue-learning float-left">Start Learning</b-link>
                                  </div>
                              </div>
                            </div>
                            <div v-if="isOpenCourse && course.lmsCourseId">
                              <div class="">
                                <div class="card-text ace_sec_txt">Continue learning by clicking on the link below</div>
                                <div class="text-center">
                                  <br>
                                  <a :href="bblmslink()" target="_blank" class="btn">
                    	          			<i class="iconLms_Blackboard"></i>
                    	  		  			<span>goto LMS</span>
                    	        		</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </b-col>

                    <b-col cols="3" class="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                        <div class="card ace_sec" aria-label="Performance Section">
                            <div class="card-header">
                                <span class="icon float-left icon-meter text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="2" aria-label="Performance summary">Performance</span>
                            </div>
                            <div class="card-body performance-section">
                            	<div class="performance-section-inner">
	                                <div class="head">Current Score</div>
	                                <div class="grade-row" v-if="!isOpenCourse">
	                                    <span class="current_score ace_sec_txt" style="background: #024673;"  :aria-label="'current score is ' + performance + '%'" v-if="course.hideScoreForStudent">N/A</span>
                                      <span class="current_score ace_sec_txt" style="background: #024673;"  :aria-label="'current score is ' + performance + '%'" v-else>
                                        {{ performance }}%
                                        <template v-if="competencySummary.overriddenTime">
                                          <span
                                            @click="openOverrideDetailModal"
                                            class="score_modify_indicator"
                                            :title="$t('overridenByAdvisorTitle')"
                                            v-b-tooltip.hover>
                                          </span>
                                        </template>
                                      </span>
	                                </div>
                                  <div class="grade-row" v-if="isOpenCourse">
	                                    <span class="current_score ace_sec_txt" style="background: #024673;"  :aria-label="'current score is ' + bbYourGrade + '%'">
                                        {{ bbYourGrade }}%
                                      </span>
	                                </div>
	                                <!--
	                                <div class="card-text">You are in the top 10 percent of your class</div>
	                                -->
                                </div>
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="6" class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                        <div class="card ace_sec" aria-label="Activity Section">
                            <div class="card-header">
                              <span class="icon float-left icon-activity text-center mr-2"></span>
                              <span class="label ace_sec_hd" role="heading" aria-level="6" aria-label="Activity summary">Activity</span>
                            </div>
                            <div class="card-body activity-section">
                                <div class="row mx-0 activity-graph-container">
                                    <div class="col-6 graph-section text-center" v-if="!isOpenCourse">
                                        <activity-bar-graph :activities="learningActivities" class="graph ace_sec_txt"></activity-bar-graph>
                                        <div class="graph_label ace_sec_txt" :aria-label="learningActivityLabel">{{ learningActivityLabel }}</div>
                                    </div>
                                    <div class="col-6 graph-section text-center" v-if="isOpenCourse">
                                      <activity-bar-graph :activities="bbGradeActivityChart" class="graph ace_sec_txt"></activity-bar-graph>
                                      <div class="graph_label ace_sec_txt" aria-label="Content Access">Grades (%)</div>
                                    </div>
                                    <div class="col-6 graph-section text-center" v-if="!isOpenCourse">
                                        <activity-bar-graph :activities="assessmentActivities" class="graph ace_sec_txt"></activity-bar-graph>
                                        <div class="graph_label ace_sec_txt" :aria-label="assessmentActivityLabel">{{ assessmentActivityLabel }}</div>
                                    </div>
                                    <div class="col-6 graph-section text-center" v-if="isOpenCourse">
                                        <activity-bar-graph :activities="bbContentAccessActivity" class="graph ace_sec_txt"></activity-bar-graph>
                                        <div class="graph_label ace_sec_txt" aria-label="Content Access">Content Access (in clicks)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </b-col>
                </b-row>

                <b-row class="activity-row dashboard-row btm_row">

                  <b-col cols="6" class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="course.showProgress">

                        <div class="card ace_sec">
                              <div class="card-header" aria-label="Progress Section">
                                <span class="icon float-left icon-progress text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="4" aria-label="Progress summary">Progress</span>
                              </div>
                            <div class="card-body progress-section">
                              <div class="progress-section-inner">
                                  <div class="ml-4 ace_sec_txt" style="margin-bottom: 14px; font-size: 1.3rem;" role="heading" aria-level="5" v-if="!isOpenCourse">Competencies</div>
                                  <div class="ml-4 progress-chart-conatiner ace_sec_txt" v-if="!isOpenCourse">
                                      <competency-pace-bar :pace="pace" :is-student-view="true"></competency-pace-bar>
                                  </div>
                                  <div v-if="isOpenCourse">
                                    <template v-for="aGa in bbAggregatedGradeActivity">
                                      <progress-bar :label="aGa.label" :completed="aGa.completedItems" :total="aGa.totalItems"></progress-bar>
                                    </template>
                                  </div>
                                </div>
                            </div>
                       </div>
                  </b-col>

                  <b-col cols="6" class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="course.showAnnouncements">
                    <div class="card ace_sec" aria-label="Announcements Section">
                          <div class="card-header">
                            <span class="icon float-left icon-channel text-center mr-2"></span>
                            <span class="label ace_sec_hd" role="heading" aria-level="7">Announcements</span>
                          </div>
                        <div class="card-body">
                          <p class="text-center ace_sec_txt" v-if="bbAnnouncements && bbAnnouncements.length === 0">
                            No new Announcements
                          </p>
                          <div class="row mb-3 ml-2" v-for="announcement in bbAnnouncements">
                              <div class="thumbnail icon-iconAdmin float-left d-flex align-items-center justify-content-center mt-1"></div>
                              <div class="announcement float-left ml-2">
                                  <div class="row admin">
                                      <small class="col-auto pr-2 red ace_sec_txt">{{announcement.subject}}</small>
                                  </div>
                                  <div class="row text">
                                      <span class="col-auto ace_sec_txt" :html="announcement.announcement"></span>
                                  </div>
                              </div>
                          </div>
                        <!--
                            <div class="row mb-3 ml-2">
                                <div class="thumbnail icon-iconAdmin float-left d-flex align-items-center justify-content-center mt-1"></div>
                                <div class="announcement float-left ml-2">
                                    <div class="row admin">
                                        <small class="col-auto pr-2 red">Administrator</small>
                                        <small class="col-auto ml-2 time pl-0">7:23 PM</small>
                                    </div>
                                    <div class="row text">
                                        <span class="col-auto">Internship at Qualcom</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3 ml-2">
                                <div class="thumbnail icon-iconAdmin float-left d-flex align-items-center justify-content-center mt-1"></div>
                                <div class="announcement float-left ml-2">
                                    <div class="row admin">
                                        <small class="col-auto pr-2 red">Administrator</small>
                                        <small class="col-auto ml-2 time pl-0">7:23 PM</small>
                                    </div>
                                    <div class="row text">
                                        <span class="col-auto">Internship at Illumina. There is only one space left. Ap…</span>
                                    </div>
                                </div>
                            </div>
                            -->
                        </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            </div>

        </div>
<!-- Override Modal -->
        <div class="modal_popup_container course_unlock_modal">
          <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Edited Overall Score and Progress</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Course :
              </div>
              <div class="col-6 fld_val">
                <div v-html="course.title"></div>
              </div>
            </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Score :
                </div>
                <div class="col-6 fld_input" v-if="competencySummary">
                  <span v-if="competencySummary.overriddenTime" class="exp_info">{{competencySummary.prePerformance?competencySummary.prePerformance:0}}%</span>
                  <span v-else class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Edited Overall Score :
                </div>
                <div class="col-6 fld_input">
                  <span class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Progress :
                </div>
                <div class="col-6 fld_input" v-if="competencySummary">
                <div class="progress-bar-label">
                  {{competencySummary.preChildrenCompleteCount}} of {{competencySummary.childrenCount}}
                </div>
                <b-progress :max="competencySummary.childrenCount">
                  <b-progress-bar :value="competencySummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="competencySummary && competencySummary.overriddenTime>0">
                <div class="col-6 ">
                  Edited Overall Progress :
                </div>
                <div class="col-6 fld_input" >
                <div class="progress-bar-label">
                  {{competencySummary.childrenCompleteCount}} of {{competencySummary.childrenCount}}
                </div>
                <b-progress :max="competencySummary.childrenCount">
                  <b-progress-bar :value="competencySummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-12 ">
                  Edited By {{competencySummary.overriddenBy}} at  {{millisToDate(competencySummary.overriddenTime)}}
                </div>
              </div>

            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="closeLearnerCourseOverrideModal">
                  {{ $tf('ok') }}
                </b-button>
              </div>
            </div>
          </b-modal>
        </div>
<!-- Override Modal -->
    </div>
</template>

<script>
import '../../../assets/module/css/course/courseDashboard.min.css'
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { DateTime } from 'luxon'
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import CompetencyPaceBar from './CompetencyPaceBar'
import ProgressLegends from './legendsPopup'
import ActivityBarGraph from './ActivityBarGraph'
import ProgressBar from './ProgressBar'

export default {
  name: 'course-dashbaord',
  props: ['uuid', 'showLastActivity'],
  components: {
    CourseNav,
    CourseHeader,
    CompetencyPaceBar,
    ProgressLegends,
    ActivityBarGraph,
    ProgressBar
  },
  data: () => {
    return {
      isCourseDetailLoaded: false,
      isContinueLearningReady: false,
      continueLearningOptions: [],
      continueLearningType: 'LearningContent',
      learningActivityLabel: '',
      assessmentActivityLabel: '',
      pace: {idealPace: 0, classPace: 0, userPace: 0, totalPace: 0}
    }
  },

  mounted () {
    if (!this.isStudentLogin) {
      return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.uuid } })
    }
    this.loadCourse()
  },

  updated () {
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.showLastActivity && this.$refs.continueLearning) {
          this.$refs.continueLearning.$el.click()
        }
      })
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearning',
      'loadContinueLearningLast',
      'loadClassSummaryWithPeer',
      'loadBlackboardCourseAccess',
      'loadBlackboardContentAccess',
      'loadBlackboardAnnouncements',
      'loadBlackboardGradeActivity',
      'loadBlackboardAggregatedGradeActivity',
      'loadLogDashboardActivity'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.uuid).then(res => {
        this.loadLogDashboardActivity({action: 'viewCourseDashboard', page: 'courseDashboard', link: '', entityUuid: this.uuid})
        if (this.isOpenCourse && !this.course.lmsCourseId) {
          return this.$router.push({ name: 'courseDetail', params: { uuid: this.uuid } })
        }
        if (this.isOpenCourse && this.course.lmsCourseId) {
          this.loadBlackboardCourseAccess(this.course.lmsCourseId)
          this.loadBlackboardContentAccess(this.course.lmsCourseId)
          this.loadBlackboardAnnouncements(this.course.lmsCourseId)
          this.loadBlackboardGradeActivity(this.course.lmsCourseId)
          this.loadBlackboardAggregatedGradeActivity(this.course.lmsCourseId).then(res => {
          })
        }
        if (res && res.uuid) {
          this.loadContinueLearning(this.uuid)
          this.loadContinueLearningLast({uuid: this.uuid, loadDataFromServer: true}).then((response) => {
            if (response) {
              this.isContinueLearningReady = true
              this.continueLearningOptions = response
              if (((this.course.courseType === 'SELECTIVE_RELEASE') || (this.course.courseType === 'CONVERSATION_QUEST')) && this.continueLearningOptions.length > 0) {
                return this.$router.push({ name: 'entityDetailSR', params: { uuid: this.course.uuid, entityType: this.continueLearningType, entityUuid: this.continueLearningOptions[0].uuid, subTopicUuid: this.continueLearningOptions[0].ancestor } })
              }
            }
          })
          this.isCourseDetailLoaded = true
          this.loadClassSummaryWithPeer({entityId: this.uuid}).then(res => {
            if (res) {
              this.pace.idealPace = res.idealPace
              this.pace.classPace = res.classPace
              this.pace.userPace = res.userPace
              this.pace.totalPace = res.totalPace
            }
          })
        }
      })
    },
    openOverrideDetailModal () {
      this.$refs.learnerCourseOverrideModal.show()
    },
    closeLearnerCourseOverrideModal () {
      this.$refs.learnerCourseOverrideModal.hide()
    },
    millisToDate (millis) {
      if(!millis){
        return "N/A"
      }
      return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
    },

    bblmslink () {
      if (this.course && this.course.lmsCourseId) {
        return 'https://nu.blackboard.com/webapps/blackboard/execute/launcher?type=Course&id=_' + this.course.lmsCourseId + '_1&url='
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'competencySummary': state => state.course.competencySummary,
      'continueLearning': state => state.course.continueLearning,
      'continuLearningLast': state => state.course.continueLearningLast,
      'classSummaryWithPeer': state => state.course.classSummaryWithPeer,
      'bbCourseAccess': state => state.course.bbCourseAccess,
      'bbContentAccess': state => state.course.bbContentAccess,
      'bbGradeActivity': state => state.course.bbGradeActivity,
      'bbAggregatedGradeActivity': state => state.course.bbAggregatedGradeActivity,
      'bbAnnouncements': state => state.course.bbAnnouncements
    }),

    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    },

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      } else {
        return false
      }
    },

    learningActivities: function () {
      const classSummary = { ...this.classSummaryWithPeer }
      var activities = []
      if (classSummary.uuid !== undefined) {
        var max = (classSummary.resourceMaxTimeTaken / 1000)
        var min = (classSummary.resourceMinTimeTaken / 1000)
        var you = (classSummary.resourceTimeTaken / 1000)
        var avg = (classSummary.resourceAvgTimeTaken / 1000)
        if (max < 180) {
          this.learningActivityLabel = 'Learning Activity in Seconds'
        } else if (max > 180 && max < 10800) {
          this.learningActivityLabel = 'Learning Activity in Minutes'
          max = max / 60
          min = min / 60
          you = you / 60
          avg = avg / 60
        } else {
          this.learningActivityLabel = 'Learning Activity in Hours'
          max = max / 3600
          min = min / 3600
          you = you / 3600
          avg = avg / 3600
        }
        activities.push({name: 'Max', count: max, color: '#005391'})
        activities.push({name: 'Min', count: min, color: '#005391'})
        activities.push({name: 'You', count: you, color: '#f3c744'})
        activities.push({name: 'Avg', count: avg, color: '#005391'})
      }
      return activities
    },

    assessmentActivities: function () {
      const classSummary = { ...this.classSummaryWithPeer }
      var activities = []
      if (classSummary.uuid !== undefined) {
        var max = (classSummary.assessmentMaxTimeTaken / 1000)
        var min = (classSummary.assessmentMinTimeTaken / 1000)
        var you = (classSummary.assessmentTimeTaken / 1000)
        var avg = (classSummary.assessmentAvgTimeTaken / 1000)
        if (max < 180) {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Seconds'
        } else if (max > 180 && max < 10800) {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Minutes'
          max = max / 60
          min = min / 60
          you = you / 60
          avg = avg / 60
        } else {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Hours'
          max = max / 3600
          min = min / 3600
          you = you / 3600
          avg = avg / 3600
        }
        activities.push({name: 'Max', count: max, color: '#005391'})
        activities.push({name: 'Min', count: min, color: '#005391'})
        activities.push({name: 'You', count: you, color: '#f3c744'})
        activities.push({name: 'Avg', count: avg, color: '#005391'})
      }
      return activities
    },

    performance: function () {
      const performance = this.competencySummary.performance
      if (performance !== null ) {
        return performance ? (Number(performance).toFixed(2)) : '0.00'
      } else {
        return '0:00'
      }
    },

    bbCourseAccessActivity () {
      var activities = []
      if (this.bbCourseAccess) {
        activities.push({name: 'Max', count: this.bbCourseAccess.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbCourseAccess.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbCourseAccess.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbCourseAccess.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbContentAccessActivity () {
      var activities = []
      if (this.bbContentAccess) {
        activities.push({name: 'Max', count: this.bbContentAccess.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbContentAccess.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbContentAccess.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbContentAccess.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbGradeActivityChart () {
      var activities = []
      if (this.bbGradeActivity) {
        activities.push({name: 'Max', count: this.bbGradeActivity.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbGradeActivity.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbGradeActivity.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbGradeActivity.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbYourGrade () {
      if (this.bbGradeActivity && this.bbGradeActivity.You) {
        let performance = this.bbGradeActivity.You
        return performance.toFixed(2)
      } else {
        return '0.00'
      }
    }

  }
}
</script>

<style scoped>
    .course-nav{
      background:#e1e1e1;
      min-height: 500px;
    }
    .coure-nav-list-item{
      background:#e1e1e1;
      border: none;
    }

    .course-thumbnail{
      background:#f8f9fa;
      min-height: 500px;
    }

    .course-information{
      margin-top:20px;
    }

    .course-description{
      padding-top:20px;
    }

    .activity-row{
      padding-top:20px;
      margin-bottom:20px;
    }

    .icon-progress {
        font-size: 41px !important;
        margin-top: -5px;
    }
    .icon-activity {
        font-size:42px!important;
    }
    .icon-announcements {
        font-size:34px !important;
    }
    .icon-channel  {
        font-size: 40px!important;
        margin-top: -3px;
    }
    .icon-directions_run {
        width: 22px;
    }

    .activity-graph-container {
        margin-top:7px;
    }
    .announcement {
        width: calc(100% - 49px);
    }
    .toc_row.row_3.active_row.active_row:before {
    	top: 11px;
    }

</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseDashboard.vue